<template>
  <div class="scene">
    <div class="loader-container">
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 750 500" style="enable-background:new 0 0 750 500;" xml:space="preserve">
        <g id="Sun">
          <g>

            <ellipse transform="matrix(0.9738 -0.2272 0.2272 0.9738 -5.1789 139.7056)" style="fill:#EC644E;"
              cx="604.283" cy="92.35" rx="26.267" ry="26.267" />
            <path style="fill:#FFFFFF;" d="M584.739,90.326c0-10.63,6.31-19.78,15.39-23.91c-12.53,1.99-22.11,12.84-22.11,25.93
			c0,14.51,11.76,26.27,26.26,26.27c3.88,0,7.57-0.84,10.88-2.36c-1.35,0.22-2.74,0.33-4.16,0.33
			C596.499,116.586,584.739,104.826,584.739,90.326z" />

            <ellipse transform="matrix(0.9738 -0.2272 0.2272 0.9738 -5.1789 139.7056)"
              style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
              cx="604.283" cy="92.35" rx="26.267" ry="26.267" />
          </g>
        </g>
        <g id="Clouds">
          <g>
            <path id="cloud1" ref="cloud1Ref"
              style="fill:#FFFFFF;stroke:#9ABAE3;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
              d="M202.632,77.205h116.632c0,0-3.034-6.412-13.215-7.105c0,0-3.206-11.091-13.279-13.691c-10.073-2.599-16.485,3.986-16.485,3.986
			s-5.199-16.291-18.89-15.944c-13.691,0.347-16.29,12.304-16.29,12.304s-7.972-1.213-10.051,5.719c0,0-8.318-3.293-13.518,0.867
			c-5.199,4.159-5.372,7.625-5.372,7.625S205.752,70.62,202.632,77.205z" />

            <path id="cloud2" ref="cloud2Ref"
              style="fill:#FFFFFF;stroke:#9ABAE3;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
              d="M559.297,133.587h146.817c0,0-3.819-8.072-16.635-8.944c0,0-4.036-13.962-16.716-17.234c-12.68-3.272-20.752,5.018-20.752,5.018
			s-6.545-20.506-23.779-20.07c-17.234,0.436-20.506,15.489-20.506,15.489s-10.035-1.527-12.653,7.199
			c0,0-10.471-4.145-17.016,1.091c-6.544,5.236-6.763,9.599-6.763,9.599S563.224,125.298,559.297,133.587z" />

            <path id="cloud3" ref="cloud3Ref"
              style="fill:#FFFFFF;stroke:#9ABAE3;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
              d="M256.503,151.557c-3.147-5.725-13.307-19.024-34.757-12.514c-2.488-5.517-15.154-19.849-32.235-9.244
			c-4.368-6.87-9.918-13.166-26.541-8.892c-3.71-9.836-13.048-16.83-24.011-16.83c-13.328,0-24.29,10.317-25.608,23.539
			c-0.045,0-0.088-0.005-0.133-0.005c-1.34,0-2.645,0.098-3.918,0.262c-3.03-6.315-8.757-10.584-15.337-10.584
			c-9.504,0-17.231,8.898-17.598,20.03c-1.001-0.13-2.025-0.212-3.075-0.212c-9.962,0-18.039,6.1-18.039,13.625
			c0,0.279,0.034,0.551,0.055,0.826H256.503z" />
          </g>
        </g>
        <!-- <g id="Floor">

          <line
            style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
            x1="43.451" y1="479.06" x2="706.549" y2="479.06" />
        </g> -->
        <g id="Building_9">
          <g>

            <rect x="606.583" y="269.595"
              style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
              width="55.94" height="209.454" />
            <rect x="662.448" y="269.595" style="fill:#9ABAE3;" width="37.004" height="209.454" />
            <rect x="692.063" y="269.598" style="fill:#FFFFFF;" width="7.389" height="209.452" />

            <rect x="662.448" y="269.595"
              style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
              width="37.004" height="209.454" />

            <rect x="601.89" y="261.223"
              style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
              width="60.558" height="8.373" />

            <rect x="662.448" y="261.223" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 1366.0938 530.8178)"
              style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
              width="41.198" height="8.373" />

            <rect x="625.626" y="449.236"
              style="fill:#263238;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
              width="17.854" height="29.814" />

            <rect x="612.33" y="249.034"
              style="fill:#EC644E;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
              width="50.118" height="12.189" />

            <rect x="662.448" y="249.034"
              style="fill:#EC644E;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
              width="29.615" height="12.189" />
            <g>

              <rect x="613.347" y="278.58"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="9.155" height="9.155" />

              <rect x="629.415" y="278.58"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="9.155" height="9.155" />

              <rect x="645.482" y="278.58"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="9.155" height="9.155" />

              <rect x="613.347" y="296.787"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="9.155" height="9.155" />

              <rect x="629.415" y="296.787"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="9.155" height="9.155" />

              <rect x="645.482" y="296.787"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="9.155" height="9.155" />

              <rect x="613.347" y="314.993"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="9.155" height="9.155" />

              <rect x="629.415" y="314.993"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="9.155" height="9.155" />

              <rect x="645.482" y="314.993"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="9.155" height="9.155" />

              <rect x="613.347" y="333.2"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="9.155" height="9.155" />

              <rect x="629.415" y="333.2"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="9.155" height="9.155" />

              <rect x="645.482" y="333.2"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="9.155" height="9.155" />

              <rect x="613.347" y="351.407"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="9.155" height="9.155" />

              <rect x="629.415" y="351.407"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="9.155" height="9.155" />

              <rect x="645.482" y="351.407"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="9.155" height="9.155" />

              <rect x="613.347" y="369.613"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="9.155" height="9.155" />

              <rect x="629.415" y="369.613"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="9.155" height="9.155" />

              <rect x="645.482" y="369.613"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="9.155" height="9.155" />

              <rect x="613.347" y="387.82"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="9.155" height="9.155" />

              <rect x="629.415" y="387.82"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="9.155" height="9.155" />

              <rect x="645.482" y="387.82"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="9.155" height="9.155" />

              <rect x="613.347" y="406.027"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="9.155" height="9.155" />

              <rect x="629.415" y="406.027"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="9.155" height="9.155" />

              <rect x="645.482" y="406.027"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="9.155" height="9.155" />

              <rect x="613.347" y="424.233"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="9.155" height="9.155" />

              <rect x="629.415" y="424.233"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="9.155" height="9.155" />

              <rect x="645.482" y="424.233"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="9.155" height="9.155" />

              <rect x="668.339" y="278.58"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="9.155" height="9.155" />

              <rect x="684.406" y="278.58"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="9.155" height="9.155" />

              <rect x="668.339" y="296.787"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="9.155" height="9.155" />

              <rect x="684.406" y="296.787"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="9.155" height="9.155" />

              <rect x="668.339" y="314.993"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="9.155" height="9.155" />

              <rect x="684.406" y="314.993"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="9.155" height="9.155" />

              <rect x="668.339" y="333.2"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="9.155" height="9.155" />

              <rect x="684.406" y="333.2"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="9.155" height="9.155" />

              <rect x="668.339" y="351.407"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="9.155" height="9.155" />

              <rect x="684.406" y="351.407"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="9.155" height="9.155" />

              <rect x="668.339" y="369.613"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="9.155" height="9.155" />

              <rect x="684.406" y="369.613"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="9.155" height="9.155" />

              <rect x="668.339" y="387.82"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="9.155" height="9.155" />

              <rect x="684.406" y="387.82"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="9.155" height="9.155" />

              <rect x="668.339" y="406.027"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="9.155" height="9.155" />

              <rect x="684.406" y="406.027"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="9.155" height="9.155" />

              <rect x="668.339" y="424.233"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="9.155" height="9.155" />

              <rect x="684.406" y="424.233"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="9.155" height="9.155" />

              <rect x="668.339" y="442.44"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="9.155" height="9.155" />

              <rect x="684.406" y="442.44"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="9.155" height="9.155" />

              <rect x="668.339" y="460.647"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="9.155" height="9.155" />

              <rect x="684.406" y="460.647"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="9.155" height="9.155" />
            </g>
          </g>
        </g>
        <g id="Building_8">
          <g>
            <g>
              <polygon style="fill:#263238;"
                points="527.297,479.05 527.297,142.736 594.388,162.519 594.388,479.05 			" />
              <polygon style="fill:#FFFFFF;" points="594.39,162.517 594.39,479.049 582.751,479.049 582.751,162.517 527.3,146.167
				527.3,142.735 			" />

              <polygon
                style="fill:none;stroke:#9ABAE3;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                points="
				527.297,479.05 527.297,142.736 594.388,162.519 594.388,479.05 			" />

              <line
                style="fill:none;stroke:#9ABAE3;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="545.112" y1="175.202" x2="594.388" y2="175.202" />

              <line
                style="fill:none;stroke:#9ABAE3;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="545.112" y1="183.524" x2="594.388" y2="183.524" />

              <line
                style="fill:none;stroke:#9ABAE3;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="545.112" y1="191.846" x2="594.388" y2="191.846" />

              <line
                style="fill:none;stroke:#9ABAE3;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="545.112" y1="200.167" x2="594.388" y2="200.167" />

              <line
                style="fill:none;stroke:#9ABAE3;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="545.112" y1="208.489" x2="594.388" y2="208.489" />

              <line
                style="fill:none;stroke:#9ABAE3;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="545.112" y1="216.811" x2="594.388" y2="216.811" />

              <line
                style="fill:none;stroke:#9ABAE3;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="545.112" y1="225.132" x2="594.388" y2="225.132" />

              <line
                style="fill:none;stroke:#9ABAE3;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="545.112" y1="233.454" x2="594.388" y2="233.454" />

              <line
                style="fill:none;stroke:#9ABAE3;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="545.112" y1="241.775" x2="594.388" y2="241.775" />

              <line
                style="fill:none;stroke:#9ABAE3;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="545.112" y1="250.097" x2="594.388" y2="250.097" />

              <line
                style="fill:none;stroke:#9ABAE3;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="545.112" y1="258.419" x2="594.388" y2="258.419" />

              <line
                style="fill:none;stroke:#9ABAE3;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="545.112" y1="266.74" x2="594.388" y2="266.74" />

              <line
                style="fill:none;stroke:#9ABAE3;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="545.112" y1="275.062" x2="594.388" y2="275.062" />

              <line
                style="fill:none;stroke:#9ABAE3;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="545.112" y1="283.383" x2="594.388" y2="283.383" />

              <line
                style="fill:none;stroke:#9ABAE3;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="545.112" y1="291.705" x2="594.388" y2="291.705" />

              <line
                style="fill:none;stroke:#9ABAE3;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="545.112" y1="300.027" x2="594.388" y2="300.027" />

              <line
                style="fill:none;stroke:#9ABAE3;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="545.112" y1="308.348" x2="594.388" y2="308.348" />

              <line
                style="fill:none;stroke:#9ABAE3;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="545.112" y1="316.67" x2="594.388" y2="316.67" />

              <line
                style="fill:none;stroke:#9ABAE3;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="545.112" y1="324.991" x2="594.388" y2="324.991" />

              <line
                style="fill:none;stroke:#9ABAE3;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="545.112" y1="333.313" x2="594.388" y2="333.313" />

              <line
                style="fill:none;stroke:#9ABAE3;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="545.112" y1="341.635" x2="594.388" y2="341.635" />

              <line
                style="fill:none;stroke:#9ABAE3;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="545.112" y1="349.956" x2="594.388" y2="349.956" />

              <line
                style="fill:none;stroke:#9ABAE3;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="545.112" y1="358.278" x2="594.388" y2="358.278" />

              <line
                style="fill:none;stroke:#9ABAE3;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="545.112" y1="366.6" x2="594.388" y2="366.6" />

              <line
                style="fill:none;stroke:#9ABAE3;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="545.112" y1="374.921" x2="594.388" y2="374.921" />

              <line
                style="fill:none;stroke:#9ABAE3;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="545.112" y1="383.243" x2="594.388" y2="383.243" />

              <line
                style="fill:none;stroke:#9ABAE3;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="545.112" y1="391.564" x2="594.388" y2="391.564" />

              <line
                style="fill:none;stroke:#9ABAE3;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="545.112" y1="399.886" x2="594.388" y2="399.886" />

              <line
                style="fill:none;stroke:#9ABAE3;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="545.112" y1="408.208" x2="594.388" y2="408.208" />

              <line
                style="fill:none;stroke:#9ABAE3;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="545.112" y1="416.529" x2="594.388" y2="416.529" />

              <line
                style="fill:none;stroke:#9ABAE3;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="545.112" y1="424.851" x2="594.388" y2="424.851" />

              <line
                style="fill:none;stroke:#9ABAE3;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="545.112" y1="433.172" x2="594.388" y2="433.172" />

              <line
                style="fill:none;stroke:#9ABAE3;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="545.112" y1="441.494" x2="594.388" y2="441.494" />

              <line
                style="fill:none;stroke:#9ABAE3;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="545.112" y1="449.816" x2="594.388" y2="449.816" />

              <line
                style="fill:none;stroke:#9ABAE3;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="545.112" y1="458.137" x2="594.388" y2="458.137" />

              <line
                style="fill:none;stroke:#9ABAE3;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="545.112" y1="466.459" x2="594.388" y2="466.459" />
            </g>
            <g>

              <polygon
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                points="
				545.112,200.169 545.112,479.049 503.276,479.049 503.276,212.498 			" />
              <g>

                <line
                  style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  x1="529.744" y1="225.132" x2="505.106" y2="225.132" />

                <line
                  style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  x1="529.744" y1="233.454" x2="505.106" y2="233.454" />

                <line
                  style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  x1="529.744" y1="241.775" x2="505.106" y2="241.775" />

                <line
                  style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  x1="529.744" y1="250.097" x2="505.106" y2="250.097" />

                <line
                  style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  x1="529.744" y1="258.418" x2="505.106" y2="258.418" />

                <line
                  style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  x1="529.744" y1="266.74" x2="505.106" y2="266.74" />

                <line
                  style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  x1="529.744" y1="275.062" x2="505.106" y2="275.062" />

                <line
                  style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  x1="529.744" y1="283.383" x2="505.106" y2="283.383" />

                <line
                  style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  x1="529.744" y1="291.705" x2="505.106" y2="291.705" />

                <line
                  style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  x1="529.744" y1="300.027" x2="505.106" y2="300.027" />

                <line
                  style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  x1="529.744" y1="308.348" x2="505.106" y2="308.348" />

                <line
                  style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  x1="529.744" y1="316.67" x2="505.106" y2="316.67" />

                <line
                  style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  x1="529.744" y1="324.991" x2="505.106" y2="324.991" />

                <line
                  style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  x1="529.744" y1="333.313" x2="505.106" y2="333.313" />

                <line
                  style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  x1="529.744" y1="341.635" x2="505.106" y2="341.635" />

                <line
                  style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  x1="529.744" y1="349.956" x2="505.106" y2="349.956" />

                <line
                  style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  x1="529.744" y1="358.278" x2="505.106" y2="358.278" />

                <line
                  style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  x1="529.744" y1="366.599" x2="505.106" y2="366.599" />

                <line
                  style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  x1="529.744" y1="374.921" x2="505.106" y2="374.921" />

                <line
                  style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  x1="529.744" y1="383.243" x2="505.106" y2="383.243" />

                <line
                  style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  x1="529.744" y1="391.564" x2="505.106" y2="391.564" />

                <line
                  style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  x1="529.744" y1="399.886" x2="505.106" y2="399.886" />

                <line
                  style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  x1="529.744" y1="408.208" x2="505.106" y2="408.208" />

                <line
                  style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  x1="529.744" y1="416.529" x2="505.106" y2="416.529" />

                <line
                  style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  x1="529.744" y1="424.851" x2="505.106" y2="424.851" />

                <line
                  style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  x1="529.744" y1="433.172" x2="505.106" y2="433.172" />

                <line
                  style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  x1="529.744" y1="441.494" x2="505.106" y2="441.494" />

                <line
                  style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  x1="529.744" y1="449.816" x2="505.106" y2="449.816" />

                <line
                  style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  x1="529.744" y1="458.137" x2="505.106" y2="458.137" />

                <line
                  style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  x1="529.744" y1="466.459" x2="505.106" y2="466.459" />
              </g>
            </g>

            <polygon
              style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
              points="
				551.187,236.355 551.187,479.049 535.817,479.049 535.817,231.824 		" />
          </g>
        </g>
        <g id="Building_7_00000156545581527948238220000009736754214806175888_">
          <g>
            <g>

              <rect x="366.584" y="107.037"
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="16.833" height="33.318" />

              <path
                style="fill:#EC644E;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                d="
				M375,125.873L375,125.873c-9.469,0-17.146,7.676-17.146,17.146v145.467c0,0.309,0.251,0.56,0.56,0.56h33.171
				c0.309,0,0.56-0.251,0.56-0.56V143.019C392.146,133.549,384.469,125.873,375,125.873z" />

              <path
                style="fill:#EC644E;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                d="
				M375,138.861c-13.445,0-24.344,10.899-24.344,24.344v140.216c0,0.425,0.345,0.77,0.77,0.77h47.149c0.425,0,0.77-0.345,0.77-0.77
				V163.205C399.344,149.76,388.445,138.861,375,138.861z" />

              <path
                style="fill:#EC644E;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                d="
				M375,153.389c-17.096,0-30.954,13.859-30.954,30.954v158.969c0,0.54,0.438,0.979,0.979,0.979h59.951
				c0.541,0,0.979-0.438,0.979-0.979V184.343C405.954,167.248,392.096,153.389,375,153.389z" />
              <path style="fill:#9ABAE3;"
                d="M375,169.607L375,169.607c-20.097,0-36.389,16.292-36.389,36.389v211.381
				c0,0.635,0.515,1.151,1.151,1.151h70.477c0.635,0,1.15-0.515,1.15-1.151V205.996C411.389,185.899,395.097,169.607,375,169.607z" />
              <path style="fill:#FFFFFF;" d="M411.39,205.993v212.529h-6.972V205.993c0-18.911-14.443-34.471-32.899-36.227
				c1.149-0.108,2.31-0.163,3.481-0.163C395.093,169.603,411.39,185.901,411.39,205.993z" />
              <path
                style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                d="
				M375,169.607L375,169.607c-20.097,0-36.389,16.292-36.389,36.389v211.436c0,0.605,0.491,1.096,1.096,1.096h70.586
				c0.605,0,1.096-0.491,1.096-1.096V205.996C411.389,185.899,395.097,169.607,375,169.607z" />

              <path
                style="fill:#EC644E;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                d="
				M375,185.708c-13.049,0-23.628,10.579-23.628,23.628V417.78c0,0.413,0.334,0.747,0.747,0.747h45.761
				c0.413,0,0.747-0.334,0.747-0.747V209.336C398.628,196.286,388.049,185.708,375,185.708z" />
              <g>

                <rect x="370.358" y="207.8"
                  style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  width="9.283" height="16.337" />

                <rect x="370.358" y="237.24"
                  style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  width="9.283" height="16.337" />

                <rect x="370.358" y="266.681"
                  style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  width="9.283" height="16.337" />

                <rect x="370.358" y="296.023"
                  style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  width="9.283" height="16.337" />

                <rect x="370.358" y="325.365"
                  style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  width="9.283" height="16.337" />

                <rect x="370.358" y="354.706"
                  style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  width="9.283" height="16.337" />
              </g>

              <line
                style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="375" y1="107.037" x2="375" y2="65.023" />
            </g>
            <g>

              <rect x="317.832" y="379.899"
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="114.336" height="99.15" />

              <rect x="304.505" y="369.305"
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="26.654" height="109.745" />

              <rect x="418.841" y="369.305"
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="26.654" height="109.745" />

              <rect x="342.307" y="390.384"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="9.283" height="16.337" />

              <rect x="342.307" y="419.824"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="9.283" height="16.337" />

              <rect x="342.307" y="449.265"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="9.283" height="16.337" />

              <rect x="361.008" y="390.384"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="9.283" height="16.337" />

              <rect x="361.008" y="419.824"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="9.283" height="16.337" />

              <rect x="379.709" y="390.384"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="9.283" height="16.337" />

              <rect x="379.709" y="419.824"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="9.283" height="16.337" />

              <rect x="398.41" y="390.384"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="9.283" height="16.337" />

              <rect x="398.41" y="419.824"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="9.283" height="16.337" />

              <rect x="398.41" y="449.265"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="9.283" height="16.337" />
              <rect x="361.008" y="450.988" style="fill:#263238;" width="27.984" height="27.984" />
            </g>
          </g>
        </g>
        <g id="Building_6">
          <g>

            <rect x="161.67" y="178.03"
              style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
              width="61.543" height="300.945" />

            <polygon
              style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
              points="
			223.213,178.03 268.419,220.411 268.419,478.975 223.213,478.975 		" />
            <g>

              <polygon
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                points="
				230.888,197.407 260.949,225.59 260.949,478.975 230.888,478.975 			" />

              <line
                style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="237.969" y1="204.046" x2="237.969" y2="478.975" />

              <line
                style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="245.629" y1="211.68" x2="245.629" y2="478.975" />

              <line
                style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="253.289" y1="218.971" x2="253.289" y2="478.975" />
            </g>
            <g>

              <rect x="172.934" y="189.434"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="39.015" height="289.541" />

              <line
                style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="172.934" y1="199.925" x2="211.949" y2="199.925" />

              <line
                style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="172.934" y1="210.4" x2="211.949" y2="210.4" />

              <line
                style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="172.934" y1="220.876" x2="211.949" y2="220.876" />

              <line
                style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="172.934" y1="231.351" x2="211.949" y2="231.351" />

              <line
                style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="172.934" y1="241.827" x2="211.949" y2="241.827" />

              <line
                style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="172.934" y1="252.302" x2="211.949" y2="252.302" />

              <line
                style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="172.934" y1="262.778" x2="211.949" y2="262.778" />

              <line
                style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="172.934" y1="273.253" x2="211.949" y2="273.253" />

              <line
                style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="172.934" y1="283.729" x2="211.949" y2="283.729" />

              <line
                style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="172.934" y1="294.204" x2="211.949" y2="294.204" />

              <line
                style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="172.934" y1="304.68" x2="211.949" y2="304.68" />

              <line
                style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="172.934" y1="315.155" x2="211.949" y2="315.155" />

              <line
                style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="172.934" y1="325.631" x2="211.949" y2="325.631" />

              <line
                style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="172.934" y1="336.106" x2="211.949" y2="336.106" />

              <line
                style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="172.934" y1="346.582" x2="211.949" y2="346.582" />

              <line
                style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="172.934" y1="357.057" x2="211.949" y2="357.057" />

              <line
                style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="172.934" y1="367.533" x2="211.949" y2="367.533" />

              <line
                style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="172.934" y1="378.008" x2="211.949" y2="378.008" />

              <line
                style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="172.934" y1="388.484" x2="211.949" y2="388.484" />

              <line
                style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="172.934" y1="398.959" x2="211.949" y2="398.959" />

              <line
                style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="172.934" y1="409.435" x2="211.949" y2="409.435" />

              <line
                style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="172.934" y1="419.91" x2="211.949" y2="419.91" />

              <line
                style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="172.934" y1="430.386" x2="211.949" y2="430.386" />

              <line
                style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="172.934" y1="440.861" x2="211.949" y2="440.861" />

              <line
                style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="172.934" y1="451.337" x2="211.949" y2="451.337" />

              <line
                style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="172.934" y1="461.812" x2="211.949" y2="461.812" />

              <line
                style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                x1="172.934" y1="472.288" x2="211.949" y2="472.288" />
            </g>
          </g>
        </g>
        <g id="Building_5_00000063622976862038472620000001524082156569441711_">
          <g>

            <rect x="51.433" y="297.957"
              style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
              width="54.132" height="181.092" />
            <rect x="105.493" y="297.957" style="fill:#9ABAE3;" width="35.808" height="181.092" />
            <rect x="134.15" y="297.96" style="fill:#FFFFFF;" width="7.15" height="181.09" />

            <rect x="105.493" y="297.957"
              style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
              width="35.808" height="181.092" />

            <rect x="46.892" y="289.856"
              style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
              width="58.601" height="8.102" />

            <rect x="105.493" y="289.856" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 250.8515 587.8131)"
              style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
              width="39.867" height="8.102" />

            <rect x="69.861" y="453.103"
              style="fill:#263238;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
              width="17.277" height="25.947" />

            <rect x="59.779" y="263.968"
              style="fill:#EC644E;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
              width="10.974" height="25.888" />

            <rect x="76.192" y="270.729"
              style="fill:#EC644E;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
              width="8.108" height="19.126" />
            <g>
              <g>

                <rect x="61.136" y="308.475"
                  style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  width="10.008" height="19.411" />

                <rect x="58.656" y="327.886"
                  style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  width="14.968" height="4.745" />

                <line
                  style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  x1="61.136" y1="318.18" x2="71.144" y2="318.18" />
              </g>
              <g>

                <rect x="85.855" y="308.475"
                  style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  width="10.008" height="19.411" />

                <rect x="83.375" y="327.886"
                  style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  width="14.968" height="4.745" />

                <line
                  style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  x1="85.855" y1="318.18" x2="95.863" y2="318.18" />
              </g>
              <g>

                <rect x="61.136" y="343.895"
                  style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  width="10.008" height="19.411" />

                <rect x="58.656" y="363.306"
                  style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  width="14.968" height="4.745" />

                <line
                  style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  x1="61.136" y1="353.6" x2="71.144" y2="353.6" />
              </g>
              <g>

                <rect x="85.855" y="343.895"
                  style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  width="10.008" height="19.411" />

                <rect x="83.375" y="363.306"
                  style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  width="14.968" height="4.745" />

                <line
                  style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  x1="85.855" y1="353.6" x2="95.863" y2="353.6" />
              </g>
              <g>

                <rect x="61.136" y="379.315"
                  style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  width="10.008" height="19.411" />

                <rect x="58.656" y="398.725"
                  style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  width="14.968" height="4.745" />

                <line
                  style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  x1="61.136" y1="389.02" x2="71.144" y2="389.02" />
              </g>
              <g>

                <rect x="85.855" y="379.315"
                  style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  width="10.008" height="19.411" />

                <rect x="83.375" y="398.725"
                  style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  width="14.968" height="4.745" />

                <line
                  style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  x1="85.855" y1="389.02" x2="95.863" y2="389.02" />
              </g>
              <g>

                <rect x="61.136" y="414.735"
                  style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  width="10.008" height="19.411" />

                <rect x="58.656" y="434.145"
                  style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  width="14.968" height="4.745" />

                <line
                  style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  x1="61.136" y1="424.44" x2="71.144" y2="424.44" />
              </g>
              <g>

                <rect x="120.422" y="308.475"
                  style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  width="10.008" height="19.411" />

                <rect x="117.942" y="327.886"
                  style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  width="14.968" height="4.745" />

                <line
                  style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  x1="120.422" y1="318.18" x2="130.43" y2="318.18" />
              </g>
              <g>

                <rect x="120.422" y="343.895"
                  style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  width="10.008" height="19.411" />

                <rect x="117.942" y="363.306"
                  style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  width="14.968" height="4.745" />

                <line
                  style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  x1="120.422" y1="353.6" x2="130.43" y2="353.6" />
              </g>
              <g>

                <rect x="120.422" y="379.315"
                  style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  width="10.008" height="19.411" />

                <rect x="117.942" y="398.725"
                  style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  width="14.968" height="4.745" />

                <line
                  style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  x1="120.422" y1="389.02" x2="130.43" y2="389.02" />
              </g>
              <g>

                <rect x="120.422" y="414.735"
                  style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  width="10.008" height="19.411" />

                <rect x="117.942" y="434.145"
                  style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  width="14.968" height="4.745" />

                <line
                  style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  x1="120.422" y1="424.44" x2="130.43" y2="424.44" />
              </g>
              <g>

                <rect x="120.422" y="450.155"
                  style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  width="10.008" height="19.411" />

                <rect x="117.942" y="469.565"
                  style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  width="14.968" height="4.745" />

                <line
                  style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  x1="120.422" y1="459.86" x2="130.43" y2="459.86" />
              </g>
              <g>

                <rect x="85.855" y="414.735"
                  style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  width="10.008" height="19.411" />

                <rect x="83.375" y="434.145"
                  style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  width="14.968" height="4.745" />

                <line
                  style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  x1="85.855" y1="424.44" x2="95.863" y2="424.44" />
              </g>
            </g>
          </g>
        </g>
        <g id="Building_4">
          <g>

            <rect x="567.324" y="320.957"
              style="fill:#EC644E;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
              width="54.132" height="158.092" />
            <rect x="621.383" y="320.957" style="fill:#EC644E;" width="35.808" height="158.092" />
            <rect x="650.73" y="320.96" style="fill:#FFFFFF;" width="6.46" height="158.09" />

            <rect x="621.383" y="320.957"
              style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
              width="35.808" height="158.092" />

            <rect x="573.914" y="290.095"
              style="fill:#EC644E;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
              width="46.193" height="22.761" />
            <rect x="620.045" y="290.095" style="fill:#EC644E;" width="30.556" height="22.761" />
            <rect x="645.95" y="290.09" style="fill:#FFFFFF;" width="4.65" height="22.77" />

            <rect x="620.045" y="290.095"
              style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
              width="30.556" height="22.761" />

            <rect x="562.782" y="312.856"
              style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
              width="58.601" height="8.102" />

            <rect x="621.383" y="312.856" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 1282.6334 633.8131)"
              style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
              width="39.866" height="8.102" />
            <g>

              <path
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                d="
				M582.402,347.212h-7.539v-11.969c0-1.717,1.392-3.109,3.109-3.109h1.32c1.717,0,3.109,1.392,3.109,3.109V347.212z" />

              <path
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                d="
				M598.16,347.212h-7.539v-11.969c0-1.717,1.392-3.109,3.109-3.109h1.32c1.717,0,3.109,1.392,3.109,3.109V347.212z" />

              <path
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                d="
				M613.917,347.212h-7.539v-11.969c0-1.717,1.392-3.109,3.109-3.109h1.32c1.717,0,3.109,1.392,3.109,3.109V347.212z" />

              <path
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                d="
				M582.402,371.923h-7.539v-11.969c0-1.717,1.392-3.109,3.109-3.109h1.32c1.717,0,3.109,1.392,3.109,3.109V371.923z" />

              <path
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                d="
				M598.16,371.923h-7.539v-11.969c0-1.717,1.392-3.109,3.109-3.109h1.32c1.717,0,3.109,1.392,3.109,3.109V371.923z" />

              <path
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                d="
				M613.917,371.923h-7.539v-11.969c0-1.717,1.392-3.109,3.109-3.109h1.32c1.717,0,3.109,1.392,3.109,3.109V371.923z" />

              <path
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                d="
				M582.402,396.634h-7.539v-11.969c0-1.717,1.392-3.109,3.109-3.109h1.32c1.717,0,3.109,1.392,3.109,3.109V396.634z" />

              <path
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                d="
				M598.16,396.634h-7.539v-11.969c0-1.717,1.392-3.109,3.109-3.109h1.32c1.717,0,3.109,1.392,3.109,3.109V396.634z" />

              <path
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                d="
				M613.917,396.634h-7.539v-11.969c0-1.717,1.392-3.109,3.109-3.109h1.32c1.717,0,3.109,1.392,3.109,3.109V396.634z" />

              <path
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                d="
				M582.402,421.345h-7.539v-11.969c0-1.717,1.392-3.109,3.109-3.109h1.32c1.717,0,3.109,1.392,3.109,3.109V421.345z" />

              <path
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                d="
				M598.16,421.345h-7.539v-11.969c0-1.717,1.392-3.109,3.109-3.109h1.32c1.717,0,3.109,1.392,3.109,3.109V421.345z" />

              <path
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                d="
				M613.917,421.345h-7.539v-11.969c0-1.717,1.392-3.109,3.109-3.109h1.32c1.717,0,3.109,1.392,3.109,3.109V421.345z" />

              <path
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                d="
				M582.402,446.057h-7.539v-11.969c0-1.717,1.392-3.109,3.109-3.109h1.32c1.717,0,3.109,1.392,3.109,3.109V446.057z" />

              <path
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                d="
				M598.16,446.057h-7.539v-11.969c0-1.717,1.392-3.109,3.109-3.109h1.32c1.717,0,3.109,1.392,3.109,3.109V446.057z" />

              <path
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                d="
				M613.917,446.057h-7.539v-11.969c0-1.717,1.392-3.109,3.109-3.109h1.32c1.717,0,3.109,1.392,3.109,3.109V446.057z" />
            </g>
            <g>

              <path
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                d="
				M636.992,347.212h-7.539v-11.969c0-1.717,1.392-3.109,3.109-3.109h1.32c1.717,0,3.109,1.392,3.109,3.109V347.212z" />

              <path
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                d="
				M652.75,347.212h-7.539v-11.969c0-1.717,1.392-3.109,3.109-3.109h1.32c1.717,0,3.109,1.392,3.109,3.109V347.212z" />

              <path
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                d="
				M636.992,371.923h-7.539v-11.969c0-1.717,1.392-3.109,3.109-3.109h1.32c1.717,0,3.109,1.392,3.109,3.109V371.923z" />

              <path
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                d="
				M652.75,371.923h-7.539v-11.969c0-1.717,1.392-3.109,3.109-3.109h1.32c1.717,0,3.109,1.392,3.109,3.109V371.923z" />

              <path
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                d="
				M636.992,396.634h-7.539v-11.969c0-1.717,1.392-3.109,3.109-3.109h1.32c1.717,0,3.109,1.392,3.109,3.109V396.634z" />

              <path
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                d="
				M652.75,396.634h-7.539v-11.969c0-1.717,1.392-3.109,3.109-3.109h1.32c1.717,0,3.109,1.392,3.109,3.109V396.634z" />

              <path
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                d="
				M636.992,421.345h-7.539v-11.969c0-1.717,1.392-3.109,3.109-3.109h1.32c1.717,0,3.109,1.392,3.109,3.109V421.345z" />

              <path
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                d="
				M652.75,421.345h-7.539v-11.969c0-1.717,1.392-3.109,3.109-3.109h1.32c1.717,0,3.109,1.392,3.109,3.109V421.345z" />

              <path
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                d="
				M636.992,446.057h-7.539v-11.969c0-1.717,1.392-3.109,3.109-3.109h1.32c1.717,0,3.109,1.392,3.109,3.109V446.057z" />

              <path
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                d="
				M652.75,446.057h-7.539v-11.969c0-1.717,1.392-3.109,3.109-3.109h1.32c1.717,0,3.109,1.392,3.109,3.109V446.057z" />
            </g>

            <rect x="585.752" y="453.103"
              style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
              width="17.277" height="25.947" />
            <g>

              <path
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                d="
				M592.901,312.856h-7.539v-8.61c0-1.717,1.392-3.109,3.109-3.109h1.32c1.717,0,3.109,1.392,3.109,3.109V312.856z" />

              <path
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                d="
				M608.659,312.856h-7.539v-8.61c0-1.717,1.392-3.109,3.109-3.109h1.32c1.717,0,3.109,1.392,3.109,3.109V312.856z" />

              <path
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                d="
				M640.762,312.856h-7.539v-8.61c0-1.717,1.392-3.109,3.109-3.109h1.32c1.717,0,3.109,1.392,3.109,3.109V312.856z" />
            </g>
          </g>
        </g>
        <g id="Building_3_00000054249327561220723260000005618637096911213980_">
          <g>

            <rect x="417.183" y="270.297"
              style="fill:#EC644E;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
              width="57.932" height="208.704" />
            <rect x="475.115" y="270.297" style="fill:#EC644E;" width="32.187" height="208.704" />
            <rect x="500.579" y="270.3" style="fill:#FFFFFF;" width="6.72" height="208.7" />

            <rect x="475.115" y="270.297"
              style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
              width="32.187" height="208.704" />
            <g>

              <rect x="413.168" y="263.516"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="61.947" height="6.781" />

              <rect x="407.693" y="256.736"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="67.422" height="6.78" />

              <rect x="475.115" y="263.516" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 988.0844 533.8129)"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="37.854" height="6.781" />

              <rect x="475.115" y="256.736" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 991.4301 520.2515)"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="41.2" height="6.78" />
            </g>
            <g>

              <rect x="425.375" y="279.484"
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="8.601" height="19.33" />

              <rect x="441.849" y="279.484"
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="8.601" height="19.33" />

              <rect x="458.323" y="279.484"
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="8.601" height="19.33" />

              <rect x="486.908" y="279.484"
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="8.601" height="19.33" />

              <rect x="425.375" y="312.272"
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="8.601" height="19.33" />

              <rect x="441.849" y="312.272"
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="8.601" height="19.33" />

              <rect x="458.323" y="312.272"
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="8.601" height="19.33" />

              <rect x="486.908" y="312.272"
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="8.601" height="19.33" />

              <rect x="425.375" y="345.06"
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="8.601" height="19.33" />

              <rect x="441.849" y="345.06"
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="8.601" height="19.33" />

              <rect x="458.323" y="345.06"
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="8.601" height="19.33" />

              <rect x="486.908" y="345.06"
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="8.601" height="19.33" />

              <rect x="425.375" y="377.849"
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="8.601" height="19.33" />

              <rect x="441.849" y="377.849"
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="8.601" height="19.33" />

              <rect x="458.323" y="377.849"
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="8.601" height="19.33" />

              <rect x="486.908" y="377.849"
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="8.601" height="19.33" />

              <rect x="425.375" y="410.637"
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="8.601" height="19.33" />

              <rect x="441.849" y="410.637"
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="8.601" height="19.33" />

              <rect x="458.323" y="410.637"
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="8.601" height="19.33" />

              <rect x="486.908" y="410.637"
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="8.601" height="19.33" />

              <rect x="425.375" y="443.425"
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="8.601" height="19.33" />

              <rect x="458.323" y="443.425"
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="8.601" height="19.33" />

              <rect x="486.908" y="443.425"
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="8.601" height="19.33" />
            </g>
            <rect x="440.984" y="443.425" style="fill:#263238;" width="10.33" height="35.847" />

            <line
              style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
              x1="417.183" y1="305.543" x2="507.302" y2="305.543" />

            <line
              style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
              x1="417.183" y1="338.331" x2="507.302" y2="338.331" />

            <line
              style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
              x1="417.183" y1="371.12" x2="507.302" y2="371.12" />

            <line
              style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
              x1="417.183" y1="403.908" x2="507.302" y2="403.908" />

            <line
              style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
              x1="417.183" y1="436.696" x2="507.302" y2="436.696" />
            <g>

              <rect x="420.143" y="220.411"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="50.314" height="28.036" />

              <rect x="428.075" y="248.448"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="4.46" height="8.182" />

              <rect x="457.783" y="248.448"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="4.46" height="8.182" />
            </g>
          </g>
        </g>
        <g id="Building_2">
          <g>

            <rect x="238.032" y="234.43"
              style="fill:#EC644E;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
              width="63.089" height="244.545" />
            <g>

              <rect x="301.121" y="234.43" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 632.9884 713.4045)"
                style="fill:#EC644E;" width="30.747" height="244.545" />
              <rect x="323.955" y="234.43" style="fill:#FFFFFF;" width="7.91" height="244.54" />

              <rect x="301.121" y="234.43" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 632.9884 713.4045)"
                style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="30.747" height="244.545" />
            </g>
            <g>

              <rect x="245.948" y="245.84"
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="47.256" height="8.476" />

              <rect x="245.948" y="263.729"
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="47.256" height="8.476" />

              <rect x="245.948" y="281.618"
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="47.256" height="8.476" />

              <rect x="245.948" y="299.507"
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="47.256" height="8.476" />

              <rect x="245.948" y="317.396"
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="47.256" height="8.476" />

              <rect x="245.948" y="335.285"
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="47.256" height="8.476" />

              <rect x="245.948" y="353.174"
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="47.256" height="8.476" />

              <rect x="245.948" y="371.062"
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="47.256" height="8.476" />

              <rect x="245.948" y="388.951"
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="47.256" height="8.476" />

              <rect x="245.948" y="406.84"
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="47.256" height="8.476" />

              <rect x="245.948" y="424.729"
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="47.256" height="8.476" />

              <rect x="245.948" y="442.618"
                style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="47.256" height="8.476" />

              <rect x="310.198" y="245.84"
                style="fill:#263238;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="21.67" height="8.476" />

              <rect x="310.198" y="263.729"
                style="fill:#263238;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="21.67" height="8.476" />

              <rect x="310.198" y="281.618"
                style="fill:#263238;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="21.67" height="8.476" />

              <rect x="310.198" y="299.507"
                style="fill:#263238;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="21.67" height="8.476" />

              <rect x="310.198" y="317.396"
                style="fill:#263238;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="21.67" height="8.476" />

              <rect x="310.198" y="335.285"
                style="fill:#263238;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="21.67" height="8.476" />

              <rect x="310.198" y="353.174"
                style="fill:#263238;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="21.67" height="8.476" />

              <rect x="310.198" y="371.062"
                style="fill:#263238;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="21.67" height="8.476" />

              <rect x="310.198" y="388.951"
                style="fill:#263238;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="21.67" height="8.476" />

              <rect x="310.198" y="406.84"
                style="fill:#263238;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="21.67" height="8.476" />

              <rect x="310.198" y="424.729"
                style="fill:#263238;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="21.67" height="8.476" />

              <rect x="310.198" y="442.618"
                style="fill:#263238;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="21.67" height="8.476" />
            </g>
          </g>
        </g>
        <g id="Building_1_00000049207444798304626650000007752276654399171729_">
          <g>

            <rect x="120.286" y="343.126"
              style="fill:#EC644E;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
              width="68.874" height="135.849" />
            <g>

              <rect x="189.16" y="343.126" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 394.2587 822.1004)"
                style="fill:#EC644E;" width="15.94" height="135.849" />
              <rect x="201.58" y="343.13" style="fill:#FFFFFF;" width="3.52" height="135.84" />

              <rect x="189.16" y="343.126" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 394.2587 822.1004)"
                style="fill:none;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="15.94" height="135.849" />
            </g>
            <g>
              <g>

                <rect x="130.34" y="356.197"
                  style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  width="7.973" height="17.172" />

                <rect x="127.234" y="372.408"
                  style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  width="14.185" height="4.543" />
              </g>
              <g>

                <rect x="150.736" y="356.197"
                  style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  width="7.973" height="17.172" />

                <rect x="147.63" y="372.408"
                  style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  width="14.185" height="4.543" />
              </g>
              <g>

                <rect x="171.132" y="356.197"
                  style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  width="7.973" height="17.172" />

                <rect x="168.027" y="372.408"
                  style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  width="14.185" height="4.543" />
              </g>
              <g>

                <rect x="194.628" y="356.197"
                  style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  width="5.002" height="17.172" />

                <rect x="192.68" y="372.408"
                  style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  width="8.899" height="4.543" />
              </g>
              <g>

                <rect x="130.34" y="386.374"
                  style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  width="7.973" height="17.172" />

                <rect x="127.234" y="402.585"
                  style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  width="14.185" height="4.543" />
              </g>
              <g>

                <rect x="150.736" y="386.374"
                  style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  width="7.973" height="17.172" />

                <rect x="147.63" y="402.585"
                  style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  width="14.185" height="4.543" />
              </g>
              <g>

                <rect x="171.132" y="386.374"
                  style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  width="7.973" height="17.172" />

                <rect x="168.027" y="402.585"
                  style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  width="14.185" height="4.543" />
              </g>
              <g>

                <rect x="194.628" y="386.374"
                  style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  width="5.002" height="17.172" />

                <rect x="192.68" y="402.585"
                  style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  width="8.899" height="4.543" />
              </g>
              <g>

                <rect x="130.34" y="416.552"
                  style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  width="7.973" height="17.172" />

                <rect x="127.234" y="432.762"
                  style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  width="14.185" height="4.543" />
              </g>
              <g>

                <rect x="150.736" y="416.552"
                  style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  width="7.973" height="17.172" />

                <rect x="147.63" y="432.762"
                  style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  width="14.185" height="4.543" />
              </g>
              <g>

                <rect x="171.132" y="416.552"
                  style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  width="7.973" height="17.172" />

                <rect x="168.027" y="432.762"
                  style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  width="14.185" height="4.543" />
              </g>
              <g>

                <rect x="194.628" y="416.552"
                  style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  width="5.002" height="17.172" />

                <rect x="192.68" y="432.762"
                  style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  width="8.899" height="4.543" />
              </g>
              <g>

                <rect x="130.34" y="446.729"
                  style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  width="7.973" height="17.172" />

                <rect x="127.234" y="462.939"
                  style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  width="14.185" height="4.543" />
              </g>
              <g>

                <rect x="171.132" y="446.729"
                  style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  width="7.973" height="17.172" />

                <rect x="168.027" y="462.939"
                  style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  width="14.185" height="4.543" />
              </g>
              <g>

                <rect x="194.628" y="446.729"
                  style="fill:#9ABAE3;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  width="5.002" height="17.172" />

                <rect x="192.68" y="462.939"
                  style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                  width="8.899" height="4.543" />
              </g>
            </g>
            <g>

              <rect x="117.409" y="336.798"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="71.701" height="6.328" />

              <rect x="112.3" y="330.471"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="76.81" height="6.327" />

              <rect x="189.11" y="336.798" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 397.4431 679.9233)"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="19.223" height="6.328" />

              <rect x="189.11" y="330.471" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 400.5651 667.2683)"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="22.345" height="6.327" />

              <rect x="130.34" y="313.651"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="58.77" height="16.82" />

              <rect x="189.11" y="313.651" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 390.6887 644.1216)"
                style="fill:#FFFFFF;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                width="12.469" height="16.82" />
            </g>

            <rect x="150.212" y="448.108"
              style="fill:#263238;stroke:#263238;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
              width="9.02" height="30.867" />
          </g>
        </g>
      </svg>
      <div class="progress-container">
        <div class="progress-bar"></div>
      </div>
      <div class="loading-text">Loading...</div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import gsap from 'gsap'

const cloud1Ref = ref(null)
const cloud2Ref = ref(null)
const cloud3Ref = ref(null)

onMounted(() => {
  // Create a loading timeline
  const tl = gsap.timeline({
    repeat: -1,
  })

  // Animate each cloud with different speeds and pulsing effects
  tl.to(cloud1Ref.value, {
    x: 750,
    opacity: 0.7,
    scale: 1.1,
    duration: 8,
    ease: 'none',
  }, 0)

  tl.to(cloud2Ref.value, {
    x: 750,
    opacity: 0.8,
    scale: 1.05,
    duration: 10,
    ease: 'none',
  }, 0)

  tl.to(cloud3Ref.value, {
    x: 750,
    opacity: 0.6,
    scale: 1.15,
    duration: 12,
    ease: 'none',
  }, 0)

  // Reset positions instantly and create continuous flow
  tl.set([cloud1Ref.value, cloud2Ref.value, cloud3Ref.value], {
    x: -200,
    opacity: 1,
    scale: 1,
  })
})
</script>

<style scoped>
.scene {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.loader-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  width: 100%;
  max-width: 800px;
}

svg {
  width: 100%;
  height: auto;
  max-width: 800px;
}

.progress-container {
  width: 100%;
  height: 6px;
  background: rgba(154, 186, 227, 0.1);
  border-radius: 3px;
  overflow: hidden;
  position: relative;
}

.progress-bar {
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg,
      #9ABAE3 0%,
      #EC644E 25%,
      #9ABAE3 50%,
      #EC644E 75%,
      #9ABAE3 100%);
  background-size: 200% 100%;
  border-radius: 3px;
  animation: gradientMove 2s linear infinite;
}

.loading-text {
  color: #9ABAE3;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 1px;
  animation: fadeInOut 1.2s infinite;
}

@keyframes gradientMove {
  0% {
    background-position: 0% 0%;
  }

  100% {
    background-position: 200% 0%;
  }
}

@keyframes fadeInOut {
  0% {
    opacity: 0.5;
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0.5;
  }
}
</style>